import { useAccountTypeStructures } from "../../../hooks/useAccountTypeStructures";
import { SYSTEM_ACCOUNT_TYPE } from "./systems.constants";

export function useSystemStructures() {
  return useAccountTypeStructures(SYSTEM_ACCOUNT_TYPE);
}
